import { moveConnectedEdges } from "./moveCells";
// const mxModule = require("mxgraph")();
// const { mxUtils, mxClipboard, mxConstants, mxEvent, mxUndoManager, mxKeyHandler, mxPoint , mxEventObject ,mxRectangle} = mxModule;
import { mxUtils, mxClipboard, mxConstants, mxEvent, mxUndoManager, mxKeyHandler, mxPoint , mxEventObject ,mxRectangle } from "./graph/mxModule";

export class Common {
  constructor(graph, onClipboardChange = null) {
    this._graph = graph;
    this._undoManager = this.getUndoManager();
    this._keyHandler = null;
    this._onClipboardChange = onClipboardChange;
   
    this.zoomInMin = 3; //max scale for zooming is restricted here    
    this.zoomOutMax = 0.5; //min scale for zooming is restricted here
    
    this._graph._wireMode = false;
    this._graph._outlineVisible = true;
  }

  getUndoManager = () => {
    // Undo Manager Setup
    var undoManager = new mxUndoManager();

    const listener = function (sender, evt) {
      undoManager.undoableEditHappened(evt.getProperty("edit"));
    };

    this._graph.getModel().addListener(mxEvent.UNDO, listener);
    this._graph.getView().addListener(mxEvent.UNDO, listener);
    return undoManager;
  };

  copy() {
    if (this._graph && !this._graph.isSelectionEmpty()) {
      const cells = mxUtils.sortCells(
        this._graph.model.getTopmostCells(this._graph.getSelectionCells())
      );
      mxClipboard.copy(this._graph, cells);
      this._onClipboardChange?.(true); // Notify clipboard has content
    }
  }

  paste() {
    if (this._graph && !mxClipboard.isEmpty()) {
      const cells = mxClipboard.paste(this._graph);
      if (cells?.length) {
        this._graph.setSelectionCells(cells);
        this._graph.scrollCellToVisible(cells[0]);
      }
    }
  }

  cut() {
    if (this._graph && !this._graph.isSelectionEmpty()) {
      const cells = mxUtils.sortCells(
        this._graph.model.getTopmostCells(this._graph.getSelectionCells())
      );
      mxClipboard.copy(this._graph, cells);
      this._graph.removeCells(this._graph.getSelectionCells());
      this._onClipboardChange?.(true);
    }
  }

  zoomIn() {
    if (this._graph.view.scale <= this.zoomInMin) this._graph?.zoomIn();
  }

  zoomOut() {
    if (this._graph.view.scale >= this.zoomOutMax) this._graph?.zoomOut();
  }

  zoomFit() {
    this._graph?.fit();        
  }

  undo() {
    this._undoManager?.undo();
  }

  redo() {
    this._undoManager?.redo();
  }

  hasClipboard() {
    return mxClipboard.isEmpty();
  }

  // delete() {
  //   this._graph?.removeCells();
  // }

  delete(instancesMapRef = null) {
    if (!this._graph) return;

    const selectedCells = this._graph.getSelectionCells();

    // Update instancesMapRef if provided
    if (instancesMapRef && instancesMapRef.current) {
      Object.keys(instancesMapRef.current).forEach((key) => {
        if (selectedCells.includes(instancesMapRef.current[key]?.cell)) {
          delete instancesMapRef.current[key];
        }
      });
      //console.log("updated instancesMapRef:", instancesMapRef.current);
    }

    // Remove the cells from the graph
    this._graph.removeCells(selectedCells);
  }

  rotate() {
    const graph = this._graph;
    const cells = graph.getSelectionCells();
    if (cells?.length) {
      graph.getModel().beginUpdate();
      try {
        cells.forEach((cell) => {
          let geo = graph.getCellGeometry(cell);
          if (geo) {
            geo = geo.clone();
            geo.x += geo.width / 2 - geo.height / 2;
            geo.y += geo.height / 2 - geo.width / 2;
            [geo.width, geo.height] = [geo.height, geo.width];
            graph.getModel().setGeometry(cell, geo);

            const state = graph.view.getState(cell);
            if (state) {
              let dir = state.style[mxConstants.STYLE_DIRECTION] || "east";
              const directions = {
                east: "south",
                south: "west",
                west: "north",
                north: "east",
              };
              graph.setCellStyles(
                mxConstants.STYLE_DIRECTION,
                directions[dir],
                [cell]
              );
            }
          }
        });
      } finally {
        graph.getModel().endUpdate();
      }
    }
  }

  selectAll() {
    const cells = this._graph.getChildCells(
      this._graph.getDefaultParent(),
      true,
      true
    );
    this._graph.setSelectionCells(cells);
  }

  flipHorizontal(diagramMode) {
    const selectedCells = this._graph?.getSelectionCells();
    if (!selectedCells?.length) return;
    //always restrict to one selection
    const isSchematic = diagramMode === "schematicEditor";
    if (selectedCells[0].children?.length) {
      selectedCells[0].children.forEach((child) => {
        if (isSchematic) {
          child.geometry.x = 1 - child.geometry.x;
        } else
          if (child.name === "D" || child.name === "S") {
            child.geometry.x = 1 - child.geometry.x;
          }
      });
    }
    this._graph?.toggleCellStyles(mxConstants.STYLE_FLIPH);
  }

  flipVertical(diagramMode) {
    const selectedCells = this._graph?.getSelectionCells();
    if (!selectedCells?.length) return;
    const isSchematic = diagramMode === "schematicEditor";
    //always restrict to one selection
    if (selectedCells[0].children?.length) {
      selectedCells[0].children.forEach((child) => {
        if (isSchematic) {
          if (child.name === "D" || child.name === "S") {
            child.geometry.y = 1 - child.geometry.y;
          }
        } else {
          child.geometry.y = 1 - child.geometry.y;
        }
      });
    }
    
    this._graph?.toggleCellStyles(mxConstants.STYLE_FLIPV);
  }

  handleUndo = () => this._undoManager.undo();

  handleRedo = () => this._undoManager.redo();

moveSelectionWithEdges = (dx, dy) => {
  const graph = this._graph;
  const model = graph.getModel();
  const selectedCells = graph.getSelectionCells();

  model.beginUpdate();
  try {
     const movedEdges = new Set();
    // This alone will move vertices and automatically update edge connections
    graph.moveCells(selectedCells, dx, dy);

     selectedCells.forEach((cell) => {
      const edges = model.getEdges(cell) || [];

      edges.forEach((edge) => {
        if (!selectedCells.includes(edge) && !movedEdges.has(edge)) {
          movedEdges.add(edge);

          const geo = edge.getGeometry();
          if (geo && geo.points && geo.points.length > 0) {
            const newGeo = geo.clone();
            newGeo.points = newGeo.points.map(
              (pt) => new mxPoint(pt.x + dx, pt.y + dy)
            );
            model.setGeometry(edge, newGeo);
          }
        }
      });
    });
  } finally {
    model.endUpdate();
  }
};

  registerKeyHandlers = () => {
    if (!this._graph) return;

    // Dispose old handler if any
    this.disposeKeyHandlers();

    const keyHandler = new mxKeyHandler(this._graph);
    this._keyHandler = keyHandler;

    const moveStep = 1;

    // Arrow keys for moving
    keyHandler.bindKey(37, () => this.moveSelectionWithEdges(-moveStep, 0)); // Left
    keyHandler.bindKey(38, () => this.moveSelectionWithEdges(0, -moveStep)); // Up
    keyHandler.bindKey(39, () => this.moveSelectionWithEdges(moveStep, 0)); // Right
    keyHandler.bindKey(40, () => this.moveSelectionWithEdges(0, moveStep)); // Down

    // Clipboard
    keyHandler.bindControlKey(67, () => this.copy()); // Ctrl+C
    keyHandler.bindControlKey(88, () => this.cut()); // Ctrl+X
    keyHandler.bindControlKey(86, () => this.paste()); // Ctrl+V
  };

  disposeKeyHandlers = () => {
    if (this._keyHandler) {
      this._keyHandler.destroy();
      this._keyHandler = null;
    }
  };

  //gridEnabled and pageBreaksVisible are graph properties.
  getPageBreaksVisible = () => this._graph.pageBreaksVisible;

  togglePageBreaks = () => {    
    if (!this._graph) return;

    let graphWidth = this._graph.container.clientWidth;
    let graphHeight = this._graph.container.clientHeight;
    let pageFormatWidth = graphWidth / 6;
    let pageFormatHeight = graphHeight / 4;    
    this._graph.pageFormat = new mxRectangle(0, 0, pageFormatWidth, pageFormatHeight);
    this._graph.pageBreaksVisible = !this._graph.pageBreaksVisible;
    
    this._graph.sizeDidChange();      
    return this._graph.pageBreaksVisible;
  };

  getGridEnabled = () => this._graph.gridEnabled;

  toggleGrid = () => {    
    this._graph.gridEnabled = !this._graph.gridEnabled;
    return this._graph.gridEnabled;
  };
  
  //_outlineVisible and _wireMode are user defined graph properties. _ is added intentionally.
  getOutlineVisible = () => this._graph._outlineVisible;

  toggleOutline = () => {
    this._graph._outlineVisible = !this._graph._outlineVisible;
    return this._graph._outlineVisible;
  };

  getWireMode = () => this._graph._wireMode;

  toggleWireMode = () => {
    this._graph._wireMode = !this._graph._wireMode;
    return this._graph._wireMode;
  };
}